import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} अज्ञात चॅट मुखपृष्ठ`,
    languageButtonLabel: `भाषा`,
    languageModalTitle: `भाषा निवडा`,
    languageModalCloseLabel: `भाषा मेनू बंद करा`,
  },
  languageOptions: {
    'en-US': {
      label: `इंग्रजी (युनायटेड स्टेट्स)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `इंग्रजी (केनिया)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `इंग्रजी (नायजेरिया)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `इंग्रजी (सिंगापूर)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `पोर्तुगीज (पोर्तुगाल)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `पोर्तुगीज (ब्राझिल)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `जर्मन (जर्मनी)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `जर्मन (ऑस्ट्रिया)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `जर्मन (स्वित्झर्लंड)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `स्पॅनिश (स्पेन)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `फ्रेंच (फ्रान्स)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `इटालियन (इटली)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `डच (नेदरलँड)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `पोलिश (पोलंड)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `स्वीडिश (स्वीडन)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `डॅनिश (डेन्मार्क)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `फिनिश (फिनलंड)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `नॉर्वेजियन (नॉर्वे)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `आईसलँडिक (आइसलँड)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `जपानी (जपान)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `कोरियन (दक्षिण कोरिया)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `चीनी (चीन)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `कँटोनीज (हाँगकाँग एसएआर चीन)`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `व्हिएतनामी (व्हिएतनाम)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `थाई (थायलंड)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `इंडोनेशियन (इंडोनेशिया)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `स्वाहिली (केनिया)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `हिंदी (भारत)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `बंगाली (बांगलादेश)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `मराठी (भारत)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `तेलगू (भारत)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `फारसी (इराण)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `उर्दू (पाकिस्तान)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `पंजाबी (पाकिस्तान)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `नायजिरिअन पिजिन (नायजेरिया)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `रशियन (रशिया)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `अरबी (सौदी अरब)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `अरबी (संयुक्त अरब अमीरात)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `अरबी (कतार)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `मोरोक्को अरबी`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `तुर्की (तुर्किये)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `भाषा निवडा`,
    closeLabel: `भाषा मेनू बंद करा`,
  },
  languageHint: (ctx) => `${ctx.localesCount}+ भाषा कोणतेही खाते न बनवता वापरा.`,
  readPagePrompt: ({languageLabel}) => `${languageLabel} मध्ये हे पृष्ठ वाचा.`,
};
